import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/jianyan_ic_saoma@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-eb3f75c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "adjustment" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "单据类型", -1))
const _hoisted_4 = { class: "adjustment_item_xz" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "入库仓库", -1))
const _hoisted_6 = { class: "adjustment_item_xz" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "adjustment_title" }, "入库物料清单", -1))
const _hoisted_8 = { class: "box" }
const _hoisted_9 = { class: "adjustment_item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "工装器具", -1))
const _hoisted_11 = { class: "adjustment_item_xz" }
const _hoisted_12 = { class: "black" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "入库物料", -1))
const _hoisted_15 = { class: "adjustment_item_xz" }
const _hoisted_16 = { class: "sweep" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "扫描物料", -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "生产工序", -1))
const _hoisted_23 = { class: "adjustment_item_xz" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "质量属性", -1))
const _hoisted_26 = { class: "adjustment_item_xz" }
const _hoisted_27 = {
  key: 2,
  class: "adjustment_item"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "批次号", -1))
const _hoisted_29 = { class: "adjustment_item_xz" }
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = {
  key: 3,
  class: "adjustment_item"
}
const _hoisted_32 = { class: "adjustment_item_xz" }
const _hoisted_33 = ["onBlur", "onUpdate:modelValue"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "zw" }, null, -1))
const _hoisted_35 = { class: "footer" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer_w" }, null, -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode("提交入库")
const _hoisted_38 = [
  _hoisted_37
]

import { ref, reactive, onMounted } from 'vue'
    import { useRoute, useRouter } from "vue-router"
    import { getBarcodeContent, getListByCondition } from "@/apis/WorkOrderAPI"
    import { wOutBoundForStockUp, getMaterialItem, getListByMaterialId } from '@/apis/ExWarehouse'
    import { QRCodeType, Attribute } from '@/enum'
    import { REGULAR } from '@/utils/utils'
    import { Toast } from 'vant'
    import Warehouse from '@/components/common/Warehouse.vue'
    import Material from '@/components/common/Material.vue'

    interface verification {
        info: Array<string>,
        openCode: boolean,
        show: boolean,
        columns: Array<any>,
        show1: boolean,
        show2: boolean,
        show3: boolean,
        columns3: Array<any>,
        show4: boolean,
        columns4: Array<any>
    }

    // 清单数据验证
    interface list {
        id: string | number,
        code: string,
        attribute: string,
        dw: string,
        wlId: string,
        wlName: string,
        wlCompany: string,
        gxId: string,
        gxName: string,
        sxId: string,
        sxName: string,
        pch: string,
        num: string,
        type: boolean // 判断有没有工序
    }

    // 单据类型/入库仓库数据验证
    interface ckVerification {
        warehouseName: string,
        warehouseId: string,
        documentTypeName: string,
        documentTypeId: string,
        warehouseAttribute: string
    }

    // 单据类型/入库仓库
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()
    const router = useRouter()

    // 控制页面数据验证
    let dataValue = ref<ckVerification>({
        warehouseName: '',
        warehouseId: '',
        warehouseAttribute: '',
        documentTypeName: '库存调整',
        documentTypeId: '28'
    })

    // 插入物料详细索引
    let index = ref<number>()

    // 入库清单
    let list = ref<Array<list>>([])

    // 控制下拉显示/隐藏/数据
    let showList = reactive<verification>({
        info: [],
        openCode: false,
        show: false,
        // 13 客返返修入库
        // 17 客退返修入库
        // 28 库存调整
        columns: [{ text: '库存调整', id: '28' }],
        // ,{ text: '客返检验入库', id: '1' },{ text: '客退检验入库', id: '2' }],
        show1: false,
        show2: false,
        show3: false,
        columns3: [],
        show4: false,
        columns4: []
    })

    // 删除对应的工装
    const dele = (i: number): void => {
        if (list.value.length === 1) {
            Toast.fail({ message: "至少保留一个工装" })
            return
        }
        list.value.splice(i, 1)
    }

    // 提交调整入库
    const submit = () => {
        let isOpen: boolean = true
        if (!dataValue.value.documentTypeId) return Toast.fail({ message: '单据类型不能为空' })
        if (!dataValue.value.warehouseId) return Toast.fail({ message: '入库仓库不能为空' })
        list.value.forEach((element: any) => {
            if (element.type && !element.gxId) {
                isOpen = false
                return Toast.fail({message: `请完善[${element.code}]的生产工序`})
            }
            if (!element.wlId) {
                isOpen = false
                return Toast.fail({message: `请完善[${element.code}]的入库物料`})
            }
            if (!element.sxId) {
                isOpen = false
                return Toast.fail({message: `请完善[${element.code}]的质量属性`})
            }
            if (!element.num) {
                isOpen = false
                return Toast.fail({message: `请完善[${element.code}]的入库数量`})
            }
        })
        if (isOpen) {
            let woutboundInBodyBeanList: Array<any> = []
            list.value.forEach((element: any) => {
                woutboundInBodyBeanList.push({
                    appliancesId: element.id,
                    batch: element.pch,
                    materialId: element.wlId,
                    num: Number(element.num),
                    procedureId: element.gxId,
                    qualityType: Number(element.sxId),
                    unitId: element.wlCompany
                })
            })
            wOutBoundForStockUp({
                type: Number(dataValue.value.documentTypeId),
                warehouseId: Number(dataValue.value.warehouseId),
                woutboundInBodyBeanList
            }).then(res => {
                if (res.code === 200) {
                    Toast.success({ message: '创建成功', forbidClick: true, duration: 2000 })
                    setTimeout(() => {
                        router.go(-1)
                    }, 2000)
                }
            })
        }
    }

    // 输入数量失去焦点校验单位
    const numBlur = (i: number): void => {
        if (Number(list.value[i].wlCompany) === 0) {
            if (!REGULAR.positiveInteger.test(list.value[i].num)) {
                list.value[i].num = ''
                Toast.fail({ message: `物料[${list.value[i].code}]只能输入正整数` })
            }
        } else if (Number(list.value[i].wlCompany) === 1) {
            if (!REGULAR.number.test(list.value[i].num)) {
                list.value[i].num = ''
                Toast.fail({ message: `物料[${list.value[i].code}]只能输入整数或小数(四位)` })
            }
        }
    }

    // 打开质量属性选择
    const openSX = (i: number) => {
        setIndexes(i)
        if (list.value[i].attribute === Attribute.HH) {  // 混合
            showList.columns4 = [{ text: '合格', id: '0' },{ text: '不良', id: '1' },{ text: '报废', id: '2' }]
        } else if (list.value[i].attribute === Attribute.HG) {  // 合格
            showList.columns4 = [{ text: '合格', id: '0' }]
        } else if (list.value[i].attribute === Attribute.BL) {  // 不良
            showList.columns4 = [{ text: '不良', id: '1' }]
        } else if (list.value[i].attribute === Attribute.BF) {  // 报废
            showList.columns4 = [{ text: '报废', id: '2' }]
        }
        showList.show4 = true
    }

    // 打开工序选择
    const openGX = async (i: number) => {
        setIndexes(i)
        let res = await getListByMaterialId({
            materialId: list.value[i].wlId
        })
        if (res.code === 200) {
            showList.columns3 = []
            res.data.forEach((element: any) => {
                showList.columns3.push({ text: element.name, id: element.id })
            })
            showList.show3 = true
        }
    }

    const openWL = (i: number) => {
        setIndexes(i)
        showList.show2 = true
    }

    // 设置插入索引
    const setIndexes = (i: number): void => {
        index.value = i
    }

    // 打开扫码
    const openCode = (type: string, i: number): void => {
        if (type === '请扫描工装码' && !dataValue.value.warehouseId) {
            Toast.fail({ message: '请先选择入库仓库' })
            return
        }
        setIndexes(i)
        showList.info = [type]
        showList.openCode = true
    }

    // 获取扫码回调
    const onDecode = async (data: string[]): Promise<void> => {
        showList.openCode = false
        let res = await getBarcodeContent({
            barcode: data[0]
        })
        if (showList.info[0] === '请扫描物料码') {
            if (res.data.barcodeType === QRCodeType.WL) {
                let wl = await getMaterialItem({ materialId: res.data.id })
                if (wl.code === 200) {
                    list.value[index.value as number].wlName = wl.data.mmodelUnionName
                    list.value[index.value as number].wlId = wl.data.id
                    list.value[index.value as number].wlCompany = wl.data.umodelAttributeData
                    let gx = await getListByMaterialId({
                        materialId: wl.data.id
                    })
                    if (gx.code === 200) {
                        list.value[index.value as number].type = gx.code === 200 && gx.data.length > 0
                        if (gx.data && gx.data.length > 0) {
                            list.value[index.value as number].gxId = gx.data[0].id
                            list.value[index.value as number].gxName = gx.data[0].name
                        }
                    }
                }
            } else {
                Toast.fail({ message: '请扫描正确的物料码' })
            }
        } else if (showList.info[0] === '请扫描工装码') {
            if (res.data.barcodeType === QRCodeType.GZ) {
                let gz = await getListByCondition({ id: res.data.id })
                if (gz.code === 200) {
                    let isOpen: boolean = true
                    list.value.forEach((element: any) => {
                        if (element.id === gz.data[0].id) {
                            isOpen = false
                            Toast.fail({ message: '工装不能重复添加' })
                        }
                    })
                    if (isOpen) {
                        if (gz.data[0].status === 1) {
                            if (dataValue.value.warehouseAttribute === Attribute.HH) {
                                setData(gz.data[0], gz.data[0].smodelLabel)
                                return
                            } else if (dataValue.value.warehouseAttribute === Attribute.HG) {
                                if (gz.data[0].smodelLabel !== Attribute.HG) {
                                    Toast.fail({ message: '工装属性必须和仓库属性一致' })
                                    return
                                }
                                setData(gz.data[0], gz.data[0].smodelLabel)
                            } else if (dataValue.value.warehouseAttribute === Attribute.BL) {
                                if (gz.data[0].smodelLabel !== Attribute.BL) {
                                    Toast.fail({ message: '工装属性必须和仓库属性一致' })
                                    return
                                }
                                setData(gz.data[0], gz.data[0].smodelLabel)
                            } else if (dataValue.value.warehouseAttribute === Attribute.BF) {
                                if (gz.data[0].smodelLabel !== Attribute.BF) {
                                    Toast.fail({ message: '工装属性必须和仓库属性一致' })
                                    return
                                }
                                setData(gz.data[0], gz.data[0].smodelLabel)
                            }
                        } else {
                            Toast.fail({ message: '请扫描空的工装' })
                        }
                    }
                }
            } else {
                Toast.fail({ message: '请扫描正确的工装码' })
            }
        }
    }

    // 插入物料清单
    const setData = async (element: any, type: string): Promise<void> => {
        let item = {
            id: element.id,
            code: element.code,
            attribute: element.smodelLabel,
            dw: list.value[list.value.length - 1].dw,
            wlId: list.value[list.value.length - 1].wlId,
            wlName: list.value[list.value.length - 1].wlName,
            gxId: list.value[list.value.length - 1].gxId,
            gxName: list.value[list.value.length - 1].gxName,
            sxId: '',
            sxName: '',
            pch: list.value[list.value.length - 1].pch,
            num: list.value[list.value.length - 1].num,
            type: list.value[list.value.length - 1].type
        }
        if (type === Attribute.HH) {
            item.sxId = '0'
            item.sxName = '合格'
        } else if (type === Attribute.HG) {
            item.sxId = '0'
            item.sxName = '合格'
        } else if (type === Attribute.BL) {
            item.sxId = '1'
            item.sxName = '不良'
        } else if (type === Attribute.BF) {
            item.sxId = '2'
            item.sxName = '报废'
        }
        list.value.unshift(item as never)
    }

    // 关闭扫码
    const closePopup = () => {
        showList.openCode = false
    }

    // 单据类型确认
    const onConfirm = (val: any): void => {
        dataValue.value.documentTypeId = val.id
        dataValue.value.documentTypeName = val.text
        showList.show = false
    }

    const onCancel = (val: any): void => {
        showList.show = false
    }

    const close = (val: any): void => {
        showList.show1 = false
    }

    // 仓库确认
    const getValue = (val: any): void => {
        if (val.tmodel.label === Attribute.HH) {
            console.log('仓库是混合')
            dataValue.value.warehouseId = val.id
            dataValue.value.warehouseName = val.name
            dataValue.value.warehouseAttribute = val.tmodel.label
        } else if (list.value[0].attribute === Attribute.HG && val.tmodel.label === Attribute.HG) {
            console.log('都是合格')
            dataValue.value.warehouseId = val.id
            dataValue.value.warehouseName = val.name
            dataValue.value.warehouseAttribute = val.tmodel.label
        } else if (list.value[0].attribute === Attribute.BL && val.tmodel.label === Attribute.BL) {
            console.log('都是不良')
            dataValue.value.warehouseId = val.id
            dataValue.value.warehouseName = val.name
            dataValue.value.warehouseAttribute = val.tmodel.label
        } else if (list.value[0].attribute === Attribute.BF && val.tmodel.label === Attribute.BF) {
            console.log('都是报废')
            dataValue.value.warehouseId = val.id
            dataValue.value.warehouseName = val.name
            dataValue.value.warehouseAttribute = val.tmodel.label
        } else {
            Toast.fail({ message: '工装属性和仓库属性不一致' })
        }
        showList.show1 = false
    }

    const close1 = (val: any): void => {
        showList.show2 = false
    }

    // 物料确认
    const getValue1 = async (val: any): Promise<void> => {
        let res = await getListByMaterialId({
            materialId: val.id
        })
        if (res.code === 200) {
            list.value[index.value as number].type = res.code === 200 && res.data.length > 0
            list.value[index.value as number].wlId = val.id
            list.value[index.value as number].wlName = val.mmodelUnionName
            list.value[index.value as number].wlCompany = val.umodelAttributeData
            list.value[index.value as number].dw = val.umodelName
            showList.columns4 = []
            if (list.value[index.value as number].attribute === Attribute.HH) {  // 混合
                showList.columns4 = [{ text: '合格', id: '0' },{ text: '不良', id: '1' },{ text: '报废', id: '2' }]
            } else if (list.value[index.value as number].attribute === Attribute.HG) {  // 合格
                showList.columns4 = [{ text: '合格', id: '0' }]
            } else if (list.value[index.value as number].attribute === Attribute.BL) {  // 不良
                showList.columns4 = [{ text: '不良', id: '1' }]
            } else if (list.value[index.value as number].attribute === Attribute.BF) {  // 报废
                showList.columns4 = [{ text: '报废', id: '2' }]
            }
            if (showList.columns4.length > 0) {
                list.value[index.value as number].sxId = showList.columns4[0].id
                list.value[index.value as number].sxName = showList.columns4[0].text
            }
            let gx = await getListByMaterialId({
                materialId: val.id
            })
            if (gx.code === 200) {
                if (gx.data && gx.data.length > 0) {
                    list.value[index.value as number].gxId = gx.data[0].id
                    list.value[index.value as number].gxName = gx.data[0].name
                }
            }
        }
        showList.show2 = false
    }

    const onConfirm2 = (val: any): void => {
        showList.show2 = false
    }

    const onCancel2 = (val: any): void => {
        showList.show2 = false
    }

    // 工序确认
    const onConfirm3 = (val: any): void => {
        list.value[index.value as number].gxId = val.id
        list.value[index.value as number].gxName = val.text
        showList.show3 = false
    }

    const onCancel3 = (val: any): void => {
        showList.show3 = false
    }

    // 质量属性确认
    const onConfirm4 = (val: any): void => {
        list.value[index.value as number].sxId = val.id
        list.value[index.value as number].sxName = val.text
        showList.show4 = false
    }

    const onCancel4 = (val: any): void => {
        showList.show4 = false
    }

    // 获取工装信息
    const getLKLKInfo = (id: string): void => {
        getListByCondition({ id })
            .then(res => {
                if (res.code === 200) {
                    if (res.data[0].status === 1) {
                        let obj = {
                            id: res.data[0].id,
                            code: res.data[0].code,
                            attribute: res.data[0].smodelLabel,
                            dw: res.data[0].umodelName,
                            wlId: '',
                            wlName: '',
                            gxId: '',
                            gxName: '',
                            sxId: '',
                            sxName: '',
                            pch: '',
                            num: ''
                        }
                        list.value.push(obj as never)
                    } else {
                        Toast.fail({ message: '请扫描空的工装' })
                    }
                }
            })
    }

    onMounted(() => {
        getLKLKInfo(route.query.id as string)
    })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_v_ScanCode = _resolveComponent("v-ScanCode")!
  const _directive_preventReClick = _resolveDirective("preventReClick")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "adjustment_item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(showList).show = true))
        }, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              style: _normalizeStyle(_unref(dataValue).documentTypeName ? 'color: #000' : '')
            }, _toDisplayString(_unref(dataValue).documentTypeName ? _unref(dataValue).documentTypeName : '点击选择'), 5),
            _createVNode(_component_van_icon, {
              name: "arrow",
              size: "20",
              color: "#999999"
            })
          ])
        ]),
        _createElementVNode("div", {
          class: "adjustment_item",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(showList).show1 = true))
        }, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", {
              style: _normalizeStyle(_unref(dataValue).warehouseName ? 'color: #000' : '')
            }, _toDisplayString(_unref(dataValue).warehouseName ? _unref(dataValue).warehouseName : '点击选择'), 5),
            _createVNode(_component_van_icon, {
              name: "arrow",
              size: "20",
              color: "#999999"
            })
          ])
        ])
      ]),
      _hoisted_7,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
        return (_openBlock(), _createBlock(_component_van_swipe_cell, {
          key: item.code
        }, {
          right: _withCtx(() => [
            _createVNode(_component_van_button, {
              style: {"height":"100%"},
              square: "",
              type: "danger",
              text: "删除",
              onClick: ($event: any) => (dele(index))
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(item.code), 1)
                ])
              ]),
              _createElementVNode("div", {
                class: "adjustment_item",
                onClick: ($event: any) => (openWL(index))
              }, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", {
                    style: _normalizeStyle(item.wlName ? 'color: #000;' : '')
                  }, _toDisplayString(item.wlName ? item.wlName : '点击选择入库物料'), 5),
                  _createVNode(_component_van_icon, {
                    name: "arrow",
                    size: "20",
                    color: "#999999"
                  })
                ])
              ], 8, _hoisted_13),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", {
                  class: "sweep_box",
                  onClick: ($event: any) => (openCode('请扫描物料码', index))
                }, _hoisted_20, 8, _hoisted_17)
              ]),
              (item.wlName && item.type)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "adjustment_item",
                    onClick: ($event: any) => (openGX(index))
                  }, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("span", {
                        style: _normalizeStyle(item.gxName ? 'color: #000;' : '')
                      }, _toDisplayString(item.gxName ? item.gxName : '点击选择'), 5),
                      _createVNode(_component_van_icon, {
                        name: "arrow",
                        size: "20",
                        color: "#999999"
                      })
                    ])
                  ], 8, _hoisted_21))
                : _createCommentVNode("", true),
              (item.wlName)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "adjustment_item",
                    onClick: ($event: any) => (openSX(index))
                  }, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("span", {
                        style: _normalizeStyle(item.sxName ? 'color: #000;' : '')
                      }, _toDisplayString(item.sxName ? item.sxName : '点击选择'), 5),
                      _createVNode(_component_van_icon, {
                        name: "arrow",
                        size: "20",
                        color: "#999999"
                      })
                    ])
                  ], 8, _hoisted_24))
                : _createCommentVNode("", true),
              (item.wlName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((item.pch) = $event),
                        placeholder: "请输入"
                      }, null, 8, _hoisted_30), [
                        [_vModelText, item.pch]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (item.wlName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("span", null, "入库数量(" + _toDisplayString(item.dw) + ")", 1),
                    _createElementVNode("div", _hoisted_32, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        onBlur: ($event: any) => (numBlur(index)),
                        "onUpdate:modelValue": ($event: any) => ((item.num) = $event),
                        placeholder: "0"
                      }, null, 40, _hoisted_33), [
                        [_vModelText, item.num]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _hoisted_34,
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", {
          class: "footer_jx",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (openCode('请扫描工装码')))
        }, "继续扫码"),
        _hoisted_36,
        _withDirectives((_openBlock(), _createElementBlock("button", {
          class: "footer_tj",
          onClick: submit
        }, _hoisted_38)), [
          [_directive_preventReClick]
        ])
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _unref(showList).show,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_unref(showList).show) = $event)),
      position: "bottom",
      round: "",
      style: { height: '45%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "请选择单据类型",
          columns: _unref(showList).columns,
          onConfirm: onConfirm,
          onCancel: onCancel
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(Warehouse, {
      show: _unref(showList).show1,
      onClose: close,
      onValue: getValue
    }, null, 8, ["show"]),
    _createVNode(Material, {
      show: _unref(showList).show2,
      onClose: close1,
      onValue: getValue1
    }, null, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _unref(showList).show3,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_unref(showList).show3) = $event)),
      position: "bottom",
      round: "",
      style: { height: '45%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "请选择生产工序",
          columns: _unref(showList).columns3,
          onConfirm: onConfirm3,
          onCancel: onCancel3
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _unref(showList).show4,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_unref(showList).show4) = $event)),
      position: "bottom",
      round: "",
      style: { height: '45%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "请选择质量属性",
          columns: _unref(showList).columns4,
          onConfirm: onConfirm4,
          onCancel: onCancel4
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_v_ScanCode, {
      openCode: _unref(showList).openCode,
      infos: _unref(showList).info,
      onClosePopup: closePopup,
      onOnDecode: onDecode
    }, null, 8, ["openCode", "infos"])
  ], 64))
}
}

})